import { CoursesCategories } from "../modules";

export const CoursesCategoriesPage = () => {
  return <CoursesCategories />;
};
